module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"inactive":"inactive","active":"active"},"de":{"inactive":"inaktiv","active":"aktiv"}}')
  delete Component.options._Ctor
}
